import React from 'react';

var TableBody = function TableBody(_ref) {
  var children = _ref.children,
      className = _ref.className;
  return React.createElement("tbody", {
    className: className
  }, children);
};

TableBody.defaultProps = {
  className: null
};
TableBody.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "TableBody",
  "props": {
    "className": {
      "defaultValue": {
        "value": "null",
        "computed": false
      },
      "type": {
        "name": "string"
      },
      "required": false,
      "description": "A custom className you would like to pass to the Component"
    },
    "children": {
      "type": {
        "name": "union",
        "value": [{
          "name": "node"
        }, {
          "name": "arrayOf",
          "value": {
            "name": "node"
          }
        }]
      },
      "required": true,
      "description": "The children of the TableBody"
    }
  }
};
export default TableBody;
export { TableBody };